import React from "react";
import Header from "../common/header";
import CourseviewDetails from "../layout/view details/coursedetails-page";
import Footer from "../common/footer";



function ViewDetailsPage() {
    return (
        <>
            <Header />
            <CourseviewDetails />
            <Footer />
        </>
    );
}

export default ViewDetailsPage;